export const coreTokens = {
  color: {
    stageDeep:
      "#040507",

    stageBase:
      "#08090D",

    elevatedDark:
      "#0E1016",

    softDark:
      "#141721",

    textPrimary:
      "#F5F6FA",

    textSecondary:
      "#B6BAC5",

    textTertiary:
      "#7E8492",

    textDisabled:
      "#555B68",

    textOnAccent:
      "#FFFFFF",

    success:
      "#39D98A",

    warning:
      "#FFCA3A",

    danger:
      "#FF4D6D",

    info:
      "#6BBCFF",

    focus:
      "#B889FF",

    chromeDark:
      "#171922",

    chromeMid:
      "#2B2E3A",

    chromeLight:
      "#777D8E",

    chromeHighlight:
      "#D8DBE5",

    chromeSpecular:
      "#FFFFFF",
  },

  spacing: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    8: 32,
    10: 40,
    12: 48,
    16: 64,
  },

  radius: {
    sm: 8,
    md: 14,
    lg: 20,
    xl: 28,
    full: 999,
  },

  sizing: {
    touchMinimum: 48,

    buttonSm: 44,
    buttonMd: 48,
    buttonLg: 56,

    avatarSm: 32,
    avatarMd: 44,
    avatarLg: 64,
    avatarHero: 96,
  },

  layout: {
    gutterCompact: 16,
    gutterStandard: 24,
    gutterWide: 32,

    maxContent: 1180,
    maxPrompt: 680,
    maxModal: 620,
    maxSettings: 760,
  },

  motion: {
    instant: 0,
    fast: 140,
    normal: 240,
    slow: 420,
    hero: 650,
  },
} as const;
